import React, { createContext, useContext, useRef } from 'react';
import { useResizeObserverState } from '../../../../../../../../hooks/useResizeObserverState';

const HeaderRefContext = createContext();
const HeaderSizeContext = createContext();

export const useHeaderRef = () => useContext(HeaderRefContext);
export const useHeaderSize = () => useContext(HeaderSizeContext);

export const HeaderSizeCalculatorProvider = ({ children }) => {
  const ref = useRef(null);

  const height = useResizeObserverState(ref, {
    compute: (el) => {
      return el?.getBoundingClientRect().height;
    },
    defaultValue: 0,
  });

  return (
    <HeaderRefContext.Provider value={ref}>
      <HeaderSizeContext.Provider value={height}>
        {children}
      </HeaderSizeContext.Provider>
    </HeaderRefContext.Provider>
  );
};
